import { useRef } from 'react';

import FadeIn from 'react-fade-in';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import Button from '~/components/Button';
import Input from '~/components/Material/Input';
import AuthLayout from '~/layouts/Auth';
import yup from '~/libs/yup';
import api from '~/services/api';

import {
  Container,
  FormContainer,
  Title,
  ButtonContainer,
  ButtonText,
} from './styles';

const ForgotPassword = () => {
  const formRef = useRef(null);
  const history = useHistory();

  // const getIllustration = () => {
  //   const number = Math.floor(Math.random() * 1);
  //   const Illustrations = [<SVG1 />];

  //   return Illustrations[number];
  // };

  const validate = async (data) => {
    try {
      const schema = yup.object().shape({
        email: yup.string().email().required().label('E-mail'),
      });

      const result = await schema.validate(data, {
        abortEarly: false,
        stripUnknown: true,
      });

      return result;
    } catch (err) {
      const validationErrors = {};
      if (err) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }

      return false;
    }
  };

  const handleSubmit = async (formData) => {
    try {
      const data = await validate(formData);

      if (data) {
        const res = await api.post('/forgot-password', data);

        if (res.status === 200) history.push('/recuperar-senha');
      }
    } catch (err) {
      toast.error('Error!');
    }
  };

  return (
    <AuthLayout>
      <Container>
        <FormContainer ref={formRef} onSubmit={handleSubmit}>
          <FadeIn>
            <Title>Esqueci minha senha</Title>
            <Input name="email" label="E-mail" />
            <Button type="submit" label="Solicitar troca de senha" />
            <ButtonContainer>
              <ButtonText to="/login">voltar para o login</ButtonText>
            </ButtonContainer>
          </FadeIn>
        </FormContainer>
      </Container>
    </AuthLayout>
  );
};

export default ForgotPassword;
